module.exports = __webpack_public_path__ + "assets/img/img-detail-sp.0d7cc9b2.jpg";